import React from 'react';
import { render } from 'react-dom';
import ApplicationWidget from './components/application/ApplicationWidget';

var itemApplicationContainer = document.getElementById('ItemApplicationWidget');

if (itemApplicationContainer != null) {
    render(<ApplicationWidget {...(itemApplicationContainer.dataset)} />, itemApplicationContainer);
}